
import { Dialog } from "primereact/dialog";
import { IMajorTech } from "../../models/MajorTech";
import { ILogin, IPermissionProps } from "../../models/Login";

import { useForm } from "react-hook-form";
import { JVInput } from "../../shared/JVInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { useEffect } from "react";

interface IProps {
    singledata: IMajorTech,
    open: boolean,
    hideHistory: () => void,
    toast: any,
    permissions?: IPermissionProps
}
const schema = yup.object({
    // sales_Manager_MaxPer: yup.number().typeError("should be a number").required("remote rate is required").nullable(),
    // sales_Team_Lead_MaxPer: yup.number().typeError("should be a number").required("onsite rate is required").nullable(),
    // sales_Resource_Manager_MaxPer: yup.number().typeError("should be a number").required("lead rate is required").nullable(),
    // sales_Head_MaxPer: yup.number().typeError("should be a number").required("architect rate is required").nullable(),
    // normal_Recruiter_MaxPer: yup.number().typeError("should be a number").required("remote rate is required").nullable(),
    // recruiter_Team_Lead_MaxPer: yup.number().typeError("should be a number").required("onsite rate is required").nullable(),
    // recruiter_Resource_Manager_MaxPer: yup.number().typeError("should be a number").required("lead rate is required").nullable(),
    // recruitment_Head_MaxPer: yup.number().typeError("should be a number").required("architect rate is required").nullable(),
});
export const UserPerForm = (props: IProps) => {

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: props.singledata,
        shouldFocusError: false
    });


    const saveToDB = async (body: IMajorTech) => {
        const response = await Fetch("Requirement_CateGoryLInfo/updatedRate", "PUT", body, `Req_CategoryID=${props.singledata.req_CategoryID}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Saved Sucessfully", life: 3000 });
            props.hideHistory();
        }
    }



    const onHide = () => {
        props.hideHistory();
    }

    useEffect(() => {
        reset(props.singledata);
    }, [props.singledata]);

    console.log(props.singledata,)
    const onSubmit = (data: IMajorTech) => {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Update Incentive Percentages" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={3} label="Sales Mananger (%age)" control={control} name="sales_Manager_MaxPer" />
                <JVInput column={3} label="Sales Team Lead (%age)" control={control} name="sales_Team_Lead_MaxPer" />
                <JVInput column={3} label="Sales RM (%age)" control={control} name="sales_Resource_Manager_MaxPer" />
                <JVInput column={3} label="Sales Head (%age)" control={control} name="sales_Head_MaxPer" />
                <JVInput column={3} label="Normal Recruiter (%age)" control={control} name="normal_Recruiter_MaxPer" />
                <JVInput column={3} label="Recruiter Lead (%age)" control={control} name="recruiter_Team_Lead_MaxPer" />
                <JVInput column={3} label="Recruiter RM (%age)" control={control} name="recruiter_Resource_Manager_MaxPer" />
                <JVInput column={3} label="Recruiter Head (%age)" control={control} name="recruitment_Head_MaxPer" />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>

        </Dialog>
    );
}